import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import Breakpoints from '../../design-utils/breakpoints';

// This function creates a set of function that helps us create multipart component styles.
const helpers = createMultiStyleConfigHelpers(['navContainer']);

const NavSections = helpers.defineMultiStyleConfig({
  baseStyle: {
    navContainer: {
      position: 'sticky',
      inset: 0,
      top: '-1px',
      width: '100%',
      margin: '0 auto',
      padding: '1rem 0',
      background: 'white',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1rem',
      flexWrap: 'wrap',
      zIndex: 1,
      bg: 'bg.default',
      [`@media (max-width: ${Breakpoints.sm})`]: {
        display: 'none',
      },
    },
    buttonTitle: {
      textTransform: 'uppercase',
      fontWeight: 400,
      '&:hover': {
        borderBottom: '1px solid',
        borderColor: '#000',
        fontWeight: 700,
      },
      '&[data-active="true"]': {
        borderBottom: '1px solid',
        borderColor: '#000',
        fontWeight: 700,
      },
    },
  },
  sizes: {},
  variants: {},
  defaultProps: {},
});

export default NavSections;
